import { CONFIG } from '../../config/index';
export const digicatStore = [
    {
        title : "updateDigicatStatusData",
        actionPrefix: 'updateDigicatStatus',
        message: 'Product Status Updated Successfully!',
        errorMessage : "Failed to Update Status of the Selected Products!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/update/product/status`,
        }
    },
    {
        title : "getSamplingCostingFormData",
        actionPrefix: 'getSamplingCostingForm',
        errorMessage : "Failed to Get the Sampling & Costing Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/vendorportal/managevendor/find/all/vendor`,
        }
    },
    {
        title : "updateSamplingCostingFormData",
        actionPrefix: 'updateSamplingCostingForm',
        messgae : "Sampling & Costing Form Submitted Successfully!",
        errorMessage : "Failed to Update the Sampling & Costing Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/insert/sample/cost`,
        }
    },
    {
        title : "getDigicatMasterData",
        actionPrefix: 'getDigicatMaster',
        errorMessage : "Failed to Get the Category Data for Products!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/master/data`,
        }
    },
    {
        title : "getDigicatMasterDetailsData",
        actionPrefix: 'getDigicatMasterDetails',
        errorMessage : "Failed to Get the Attribute Details for Products!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/master/data`,
        }
    },
    {
        title : "saveDigicatMasterDetailsData",
        actionPrefix: 'saveDigicatMasterDetails',
        errorMessage : "Failed to save the details!",
        message : "Entries saved successfully in master data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/insert/master/data`,
        }
    },
    {
        title : "createProductData",
        actionPrefix: 'createProduct',
        message : "Product Updated Successfully!",
        errorMessage : "Failed to Update Product With Provided Details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}${payload?.[0]?.productId ? "/admin/catalogue/product/library/update" : "/admin/catalogue/product/library/create"}`,
        }
    },
    {
        title : "getProductDetailData",
        actionPrefix: 'getProductDetail',
        errorMessage : "Failed to Get Product With Provided Details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/product/detail`,
        }
    },
    {
        title : "createFabricData",
        actionPrefix: 'createFabric',
        message : "Fabric or Cost sheet created successfully!",
        errorMessage : "Failed to create fabric or Cost sheet with provided details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/create/fabric`,
        }
    },
    {
        title : "updateFabricData",
        actionPrefix: 'updateFabric',
        message : "Fabric updated successfully!",
        errorMessage : "Failed to update fabric with provided details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/update/fabric`,
        }
    },
    {
        title : "loadFabricData",
        actionPrefix: 'loadFabric',
        errorMessage : "Failed to load fabic with provided number!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/by/fabric`,
        }
    },
    {
        title : "createCostsheetData",
        actionPrefix: 'createCostsheet',
        message : "Cost sheet created successfully!",
        errorMessage : "Failed to create Cost sheet with provided details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/create/cost/sheet`,
        }
    },
    {
        title : "updateCostsheetData",
        actionPrefix: 'updateCostsheet',
        message : "Cost sheet updated successfully!",
        errorMessage : "Failed to update cost sheet with provided details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/update/cost/sheet`,
        }
    },
    {
        title : "loadCostsheetData",
        actionPrefix: 'loadCostsheet',
        errorMessage : "Failed to load cost sheet with provided number!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/by/cost/sheet`,
        }
    },
    {
        title : "getDigicatalogueFiltersData",
        actionPrefix: 'getDigicatalogueFilters',
        errorMessage : "Failed to get the digicatalogue filters!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/view/filters`,
        }
    },
    {
        title : "deleteProductsData",
        actionPrefix: 'deleteProducts',
        errorMessage : "Failed to delete the product!",
        message : "Product deleted successfully!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/product/delete`,
        }
    },
    {
        title : "dispatchSampleCostsheetData",
        actionPrefix: 'dispatchSampleCostsheet',
        errorMessage : "Failed to Dispath Request!",
        message : "Request Dispatched successfully!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/dispatch/sample`,
        }
    },
    {
        title : "catUpdateStatusSampleCostingData",
        actionPrefix: 'catUpdateStatusSampleCosting',
        errorMessage : "Failed to Dispath Request!",
        message : "Request Dispatched successfully!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/update/status/sample/costing`,
        }
    },
    {
        title : "getProductDetailCustomData",
        actionPrefix: 'getProductDetailCustom',
        errorMessage : "Failed to Dispath Request!",
        message : "Request Dispatched successfully!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/product/detail/custom`,
        }
    },
    {
        title : "updateAndApproveProductData",
        actionPrefix: 'updateAndApproveProduct',
        message : "Product Updated & Approved Successfully!",
        errorMessage : "Failed to Update & Approve Product With Provided Details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/product/library/update`,
        }
    },
    {
        title : "createNewProductSurveyData",
        actionPrefix: 'createNewProductSurvey',
        message : "New Survey Created Successfully!",
        errorMessage : "Failed to create new product survey!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/master/create/product/survey`,
        }
    },
    {
        title : "getProductSurveyDetailsData",
        actionPrefix: 'getProductSurveyDetails',
        errorMessage : "Failed to get product survey details!",
        requestData: {
            token : false,
            buildUrl: (payload) => `${CONFIG.BASE_URL}/open/key/get/survey/detail`,
        }
    },
    {
        title : "submitProductSurveyData",
        actionPrefix: 'submitProductSurvey',
        message : "Product Survey Response Submitted Successfully!",
        errorMessage : "Failed to submit product survey response!",
        requestData: {
            token : false,
            buildUrl: (payload) => `${CONFIG.BASE_URL}/open/key/survey/feedback/submit`,
        }
    },
    {
        title : "updateProdctSurveyStatusData",
        actionPrefix: 'updateProdctSurveyStatus',
        errorMessage : "Failed to update product survey status!",
        requestData: {
            token : false,
            buildUrl: (payload) => `${CONFIG.BASE_URL}/open/key/survey/update/status`,
        }
    },
    {
        title : "getSubmittedSurveyDetailsData",
        actionPrefix: 'getSubmittedSurveyDetails',
        errorMessage : "Failed to get product survey details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/master/get/survey/feedback`,
        }
    },
    {
        title : "getCollectionsListData",
        actionPrefix: 'getCollectionsList',
        errorMessage : "Failed to get the collections List!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/collection`,
        }
    },
    {
        title : "createNewCollectionData",
        actionPrefix: 'createNewCollection',
        errorMessage : "Failed to create a new collection!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/collection/submit`,
        }
    },
    {
        title : "getAllCollectionDetailsData",
        actionPrefix: 'getAllCollectionDetails',
        requestData: {
            method : "GET",
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/product/collection/detail`,
        }
    },
    {
        title : "resentProductSurveyEmailData",
        actionPrefix: 'resentProductSurveyEmail',
        requestData: {
            buildUrl: (payload) => `${CONFIG.NOTIFICATION_ROUTE_PROD}/product/survey/resend`,
        }
    },
    {
        title : "getCostComparisonData",
        actionPrefix: 'getCostComparison',
        errorMessage : "Failed to get Cost Comparison Details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/get/vendor/cost/comparison`,
        }
    },
    {
        title : "catSameCostHoldData",
        actionPrefix: 'catSameCostHold',
        errorMessage : "Failed to get Cost Comparison Details!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/sample/costing/hold`,
        }
    },
    {
        title : "getProductAttributeFromImageData",
        actionPrefix: 'getProductAttributeFromImage',
        errorMessage : "Failed to get attributes from the image!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/catalogue/get/image/info`,
        }
    },
    {
        title : "customerSatisfactionBreakdownData",
        actionPrefix: 'customerSatisfactionBreakdown',
        errorMessage : "Failed to get Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/survey/data`,
        }
    },
    {
        title : "topRatedProductsData",
        actionPrefix: 'topRatedProducts',
        errorMessage : "Failed to get Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/survey/data`,
        }
    },
    {
        title : "bottomRatedProductsData",
        actionPrefix: 'bottomRatedProducts',
        errorMessage : "Failed to get Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/dashboard/survey/data`,
        }
    },
    {
        title : "catUpdateBulkImageData",
        actionPrefix: 'catUpdateBulkImage',
        errorMessage : "Failed to Update Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/update/bulk/image`,
        }
    },
    {
        title : "updateProdLibraryDatailData",
        actionPrefix: 'updateProdLibraryDatail',
        errorMessage : "Failed to Update Data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/update/product/library/detail`,
        }
    },
    {
        title : "getMaterialTypeCostsheetDropdownData",
        actionPrefix: 'getMaterialTypeCostsheetDropdown',
        errorMessage : "Failed to get data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/catalogue/get/material/type`,
        }
    },
    {
        title : "getPivotTableProductData",
        actionPrefix: 'getPivotTableProduct',
        errorMessage : "Failed to get data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/catalogue/get/all/products`,
        }
    },
    {
        title : "copyVendorProductToRetailerData",
        actionPrefix: 'copyVendorProductToRetailer',
        errorMessage : "Failed to copy the vendor product to retailer!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.BASE_URL}/admin/catalogue/product/copy`,
        }
    },
    {
        title : "generateDesignNumberData",
        actionPrefix: 'generateDesignNumber',
        errorMessage : "Failed to get data!",
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/config/generate/sequence`,
        }
    },
    {
        title: "getMixPercentageData",
        actionPrefix: 'getMixPercentage',
        message: 'Request Completed Successfully',
        requestData: {
            buildUrl: (payload) => `${CONFIG.SM_BACKEND_BASE_URL}/purchase/catalogue/get/product/attributes/percentage`
        }
    },
]